import type { Prototype } from "../prototype-types";

export const brooklynBrownPrototypes: Prototype[] = [
  {
    id: "collapsible-brand-left-nav",
    name: "Collapsible Brand Left Nav",
    path: "/bb/collapsible-brand-left-nav",
    description:
      "Testing whether a collapsible left nav saves meaningful screen space on table-heavy Brand pages (Products, Orders, Bulk editor, Customers). Three variants: hover-to-expand, button toggle with subpage flyouts, and a button+hover combo.",
    owner: "Brooklyn",
    createdAt: "2026-07-17",
    lastUpdated: "2026-07-17",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/8a81e3494e7a97ee04f979c60591b224fbd03b22eea0ccfd871e11fc85ceb2b8.png",
    creationTool: "claude-code",
  },
  {
    id: "faire-truth-serum",
    name: "Faire Truth Serum",
    path: "/bb/truth-serum",
    description:
      "An honesty filter for brand storefronts. Toggle between Marketing Mode and Truth Serum Mode to see brand names, taglines, product descriptions, and badges transform from polished marketing into the unflattering reality. Two contrasting brands — one endearingly humble, one exposing cynical surplus-flipping.",
    owner: "Brooklyn",
    createdAt: "2026-05-05",
    lastUpdated: "2026-05-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.faire.com/fastly/99db2a93b06fa1bf617f5c495e02dcf6c0b76961108491217e2cf4fed8699d35.png",
    creationTool: "claude-code",
  },
  {
    id: "catalog-scorecard",
    name: "Catalog Scorecard",
    path: "/bb/catalog-scorecard",
    description:
      "Four-variant catalog listing quality scorecard: V1 health scorecard with KPI tiles, V2 listing quality score with AI-suggested fixes, V3 triage view with issue filter rail and action chips, V4 interactive prototype with right-rail data explorer (subscores, sparkline, AI-fixable issues, recent activity) and keyboard nav.",
    owner: "Brooklyn",
    createdAt: "2026-04-22",
    lastUpdated: "2026-04-28",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5a20e83d5e712548e3befced9fe2605919df68da46f1593cb52e5fd8631835e5.png",
    creationTool: "claude-code",
  },
  {
    id: "pricing-insights",
    name: "Pricing Insights",
    path: "/bb/pricing-insights",
    description:
      "PDP entry point that surfaces pricing context for retailers — showing margin vs. category average, external retail prices across channels, and a brand note explaining their pricing rationale.",
    owner: "Brooklyn",
    createdAt: "2026-03-24",
    lastUpdated: "2026-03-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/28635480ca0fa3e8c9eccbbb7545c6e543c91c6637866efaafd8edcc99c8f9b4.png",
    creationTool: "cursor",
  },
  {
    id: "catalog-dashboard",
    name: "Catalog Dashboard",
    path: "/bb/faire/catalog-dashboard",
    description:
      "Brand portal dashboard showing pricing compliance, catalog completion, and listing quality metrics with prioritized recommendations.",
    owner: "Brooklyn",
    createdAt: "2026-03-03",
    lastUpdated: "2026-03-04",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1a40743ea3eb4f81ac89acbcbc3f56c002c9bc42799fc819462c6c1dadc4fa4e.png",
    creationTool: "claude-code",
  },
  {
    id: "profit-margin-calculator",
    name: "Profit Margin Calculator",
    path: "/bb/profit-margin-calculator",
    description:
      "PDP profit margin calculator that helps retailers understand their margins before ordering. Features three variants: inline calculator, expandable accordion, and quick margin badge.",
    owner: "Brooklyn",
    createdAt: "2026-02-02",
    lastUpdated: "2026-02-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a6cac271e2f1575c6167b2ffb9c1a1b73e3401de4ca08e991fa9afe8665ae6c0.png",
    creationTool: "cursor",
  },
  {
    id: "price-discrepancy-editor",
    name: "Price Discrepancy Editor",
    path: "",
    externalUrl: "https://tutor-bead-99737861.figma.site/",
    description:
      "Bulk pricing editor to help brands review and resolve MSRP discrepancies between Faire and their website. Features dashboard alerts, editable pricing table, and feedback workflows.",
    owner: "Brooklyn",
    createdAt: "2026-02-09",
    lastUpdated: "2026-03-04",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8aa2d8c11d544ccabc59b43cdb9163dbd4489d07d1ce3913f7a1c44281144503.png",
    creationTool: "figma-make",
  },
];
